<template>
  <div class="improve-info-wrapper">
    <div class="basic-content">
      <p class="title">基本信息</p>
      <div class="item-basic">
        <span class="label">头像</span>
        <span class="right-info" @click="canChangePic"><img class="user-pic" src="../../assets/images/su@2x.png"/></span>
      </div>
      <div class="item-basic">
        <span class="label">姓名</span>
        <span class="right-info">{{userName}}</span>
      </div>
      <div class="item-basic">
        <span class="label">手机号</span>
        <span class="right-info">{{phoneNumber}}</span>
      </div>
    </div>
    <div class="divider-7pt"></div>
    <div class="basic-content">
      <p class="title">其他信息</p>
      <div class="item-basic">
        <span class="label">身份证号</span>
        <span class="right-info-select"><input class="inp margin-r" type="text" v-model="idCard" placeholder="请输入" @change="checkIdCard"/></span>
      </div>
      <div class="item-basic">
        <span class="label">性别</span>
        <span class="right-info-select" @click="sexVisible = true"><input class="inp" type="text" v-model="userSex" readonly/><img class="arrow-icon" src="../../assets/images/ou@2x.png"/></span>
      </div>
      <div class="item-basic">
        <span class="label">年龄</span>
        <span class="right-info-select"><input class="inp margin-r" type="number" v-model="userAge" placeholder="请输入" maxlength="3"/></span>
      </div>
      <div class="item-basic" @click="areaSelectHandler">
        <span class="label">所在地区</span>
        <span class="right-info-select">
          <!--<input class="inp" type="text" v-model="userArea" readonly/>-->
          <span class="show-area">{{Province ? Province : ''}} {{City ? City : ''}} {{District ? District : ''}} {{Town ? Town : ''}}</span>
          <img class="arrow-icon" src="../../assets/images/ou@2x.png"/>
        </span>
      </div>
      <div class="item-basic border-b">
        <span class="label">详细地址</span>
        <span class="right-info-select"><input class="inp margin-r" type="text" v-model="userAddress" placeholder="请输入"/></span>
      </div>
    </div>
    <!--性别选择组件-->
    <div class="sexPicker">
      <mt-popup class="popup-content"
        v-model="sexVisible"
        position="bottom">
        <mt-picker :slots="slots" @change="onValuesChange"></mt-picker>
      </mt-popup>
    </div>
    <!--省市区乡四级联动-->
    <div class="province-picker">
      <section class="showChose" v-show="showChose">
        <section class="address">
          <section class="title1">
            <span class="address-name">居住地址</span>
            <span class="close-btn" @click="closeAdd()">×</span>
          </section>
          <section class="title2">
            <!--<div class="area" @click="provinceSelected()">{{Province?Province:info[province-1].name}}</div>-->
            <div class="area" @click="provinceSelected()" :class="Province?'':'active'">{{Province?Province:'请选择'}}</div>
            <div class="area" @click="citySelected()" :class="City?'':'active'" v-show="Province">{{City?City:'请选择'}}</div>
            <div class="area" @click="districtSelected()" :class="District?'':'active'" v-show="City">{{District?District:'请选择'}}</div>
            <div class="area" @click="townSelected()" :class="Town?'':'active'" v-show="District">{{Town?Town:'请选择'}}</div>
          </section>
          <ul>
            <li class="add-list" v-for="(v,k) in info" @click="getProvinceId(v.id, v.name, k)" v-show="showProvince" :class="v.selected ? 'active' : ''">{{v.name}}</li>
            <li class="add-list" v-for="(v,k) in showCityList" @click="getCityId(v.id, v.name, k)" v-show="showCity" :class="v.selected ? 'active' : ''">{{v.name}}</li>
            <li class="add-list" v-for="(v,k) in showDistrictList" @click="getDistrictId(v.id, v.name, k)" v-show="showDistrict" :class="v.selected ? 'active' : ''">{{v.name}}</li>
            <li class="add-list" v-for="(v,k) in showTownList" @click="getTownId(v.id, v.name, k)" v-show="showTown" :class="v.selected ? 'active' : ''">{{v.name}}</li>
          </ul>
        </section>
      </section>
    </div>
    <div class="fixed-btn" @click="saveInfo">保存</div>
  </div>
</template>

<script>
import util from "../../common/utils"
  export default {
    data(){
      return {
        userName: '无名氏',
        phoneNumber: '18519628945',
        idCard: '',
        userSex: '',
        userAge: '',
        userArea: '',
        userAddress: '',
        sexVisible: false,
        slots: [
          {
            flex: 1,
            values: ['男','女'],
            className: 'slot1',
            textAlign: 'center',
            flex: 1
          }
        ],
        showChose: false, //四级联动
        showProvince: true,
        showCity: false,
        showTown: false,
        showDistrict: false,
        showCityList: false,
        showDistrictList: false,
        showTownList: false,
        province: 3,
        city: 3,
        district: 37,
        town: '',
        // GetProvinceId: 2,
        District: false,
        Province: false,
        City: false,
        Town: false,
        // v-for循环判断是否为当前
        selected: false,
        info: [
          {id: 1, name: '北京', city: [
              {id: 1, name: '北京市', district: [
                  {id: 1, name: '东城区',town: [
                      {id:1, name: '无名镇'},
                      {id:2, name: '落花乡'},
                    ]
                  },
                  {id: 2, name: '西城区'},
                  {id: 3, name: '崇文区'},
                  {id: 4, name: '宣武区'},
                  {id: 5, name: '朝阳区'},
                  {id: 6, name: '丰台区'},
                  {id: 7, name: '石景山区'},
                  {id: 8, name: '海淀区'},
                  {id: 9, name: '门头沟区'},
                  {id: 10, name: '房山区'},
                  {id: 11, name: '通州区'},
                  {id: 12, name: '顺义区'},
                  {id: 13, name: '昌平区'},
                  {id: 14, name: '大兴区'},
                  {id: 15, name: '怀柔区'},
                  {id: 16, name: '平谷区'},
                  {id: 17, name: '密云县'},
                  {id: 18, name: '延庆县'}
                ]}
            ]},
          {id: 2, name: '天津', city: [
              {id: 2, name: '天津市', district: [
                  {id: 19, name: '和平区'},
                  {id: 20, name: '河东区'},
                  {id: 21, name: '河西区'},
                  {id: 22, name: '南开区'},
                  {id: 23, name: '河北区'},
                  {id: 24, name: '红桥区'},
                  {id: 25, name: '塘沽区'},
                  {id: 26, name: '汉沽区'},
                  {id: 27, name: '大港区'},
                  {id: 28, name: '东丽区'},
                  {id: 29, name: '西青区'},
                  {id: 30, name: '津南区'},
                  {id: 31, name: '北辰区'},
                  {id: 32, name: '武清区'},
                  {id: 33, name: '宝坻区'},
                  {id: 34, name: '宁河县'},
                  {id: 35, name: '静海县'},
                  {id: 36, name: '蓟县'}
                ]}
            ]},
          {id: 3, name: '河北', city: [
              {id: 3, name: '石家庄市', district: [
                  {id: 37, name: '长安区'},
                  {id: 38, name: '桥东区'},
                  {id: 39, name: '桥西区'},
                  {id: 40, name: '新华区'},
                  {id: 41, name: '井陉矿区'},
                  {id: 42, name: '裕华区'},
                  {id: 43, name: '井陉县'},
                  {id: 44, name: '正定县'},
                  {id: 45, name: '栾城县'},
                  {id: 46, name: '行唐县'},
                  {id: 47, name: '灵寿县'},
                  {id: 48, name: '高邑县'},
                  {id: 49, name: '深泽县'},
                  {id: 50, name: '赞皇县'},
                  {id: 51, name: '无极县'},
                  {id: 52, name: '平山县'},
                  {id: 53, name: '元氏县'},
                  {id: 54, name: '赵县'},
                  {id: 55, name: '辛集市'},
                  {id: 56, name: '藁城市'},
                  {id: 57, name: '晋州市'},
                  {id: 58, name: '新乐市'},
                  {id: 59, name: '鹿泉市'}
                ]},
              {id: 4, name: '唐山市', district: [
                  {id: 60, name: '路南区'},
                  {id: 61, name: '路北区'},
                  {id: 62, name: '古冶区'},
                  {id: 63, name: '开平区'},
                  {id: 64, name: '丰南区'},
                  {id: 65, name: '丰润区'},
                  {id: 66, name: '滦县'},
                  {id: 67, name: '滦南县'},
                  {id: 68, name: '乐亭县'},
                  {id: 69, name: '迁西县'},
                  {id: 70, name: '玉田县'},
                  {id: 71, name: '唐海县'},
                  {id: 72, name: '遵化市'},
                  {id: 73, name: '迁安市'}
                ]},
              {id: 5, name: '秦皇岛市', district: [
                  {id: 74, name: '海港区'},
                  {id: 75, name: '山海关区'},
                  {id: 76, name: '北戴河区'},
                  {id: 77, name: '青龙满族自治县'},
                  {id: 78, name: '昌黎县'},
                  {id: 79, name: '抚宁县'},
                  {id: 80, name: '卢龙县'}
                ]},
              {id: 6, name: '邯郸市', district: [
                  {id: 81, name: '邯山区'},
                  {id: 82, name: '丛台区'},
                  {id: 83, name: '复兴区'},
                  {id: 84, name: '峰峰矿区'},
                  {id: 85, name: '邯郸县'},
                  {id: 86, name: '临漳县'},
                  {id: 87, name: '成安县'},
                  {id: 88, name: '大名县'},
                  {id: 89, name: '涉县'},
                  {id: 90, name: '磁县'},
                  {id: 91, name: '肥乡县'},
                  {id: 92, name: '永年县'},
                  {id: 93, name: '邱县'},
                  {id: 94, name: '鸡泽县'},
                  {id: 95, name: '广平县'},
                  {id: 96, name: '馆陶县'},
                  {id: 97, name: '魏县'},
                  {id: 98, name: '曲周县'},
                  {id: 99, name: '武安市'}
                ]},
              {id: 7, name: '邢台市', district: [
                  {id: 100, name: '桥东区'},
                  {id: 101, name: '桥西区'},
                  {id: 102, name: '邢台县'},
                  {id: 103, name: '临城县'},
                  {id: 104, name: '内丘县'},
                  {id: 105, name: '柏乡县'},
                  {id: 106, name: '隆尧县'},
                  {id: 107, name: '任县'},
                  {id: 108, name: '南和县'},
                  {id: 109, name: '宁晋县'},
                  {id: 110, name: '巨鹿县'},
                  {id: 111, name: '新河县'},
                  {id: 112, name: '广宗县'},
                  {id: 113, name: '平乡县'},
                  {id: 114, name: '威县'},
                  {id: 115, name: '清河县'},
                  {id: 116, name: '临西县'},
                  {id: 117, name: '南宫市'},
                  {id: 118, name: '沙河市'}
                ]},
              {id: 8, name: '保定市', district: [
                  {id: 119, name: '新市区'},
                  {id: 120, name: '北市区'},
                  {id: 121, name: '南市区'},
                  {id: 122, name: '满城县'},
                  {id: 123, name: '清苑县'},
                  {id: 124, name: '涞水县'},
                  {id: 125, name: '阜平县'},
                  {id: 126, name: '徐水县'},
                  {id: 127, name: '定兴县'},
                  {id: 128, name: '唐县'},
                  {id: 129, name: '高阳县'},
                  {id: 130, name: '容城县'},
                  {id: 131, name: '涞源县'},
                  {id: 132, name: '望都县'},
                  {id: 133, name: '安新县'},
                  {id: 134, name: '易县'},
                  {id: 135, name: '曲阳县'},
                  {id: 136, name: '蠡县'},
                  {id: 137, name: '顺平县'},
                  {id: 138, name: '博野县'},
                  {id: 139, name: '雄县'},
                  {id: 140, name: '涿州市'},
                  {id: 141, name: '定州市'},
                  {id: 142, name: '安国市'},
                  {id: 143, name: '高碑店市'}
                ]},
              {id: 9, name: '张家口市', district: [
                  {id: 144, name: '桥东区'},
                  {id: 145, name: '桥西区'},
                  {id: 146, name: '宣化区'},
                  {id: 147, name: '下花园区'},
                  {id: 148, name: '宣化县'},
                  {id: 149, name: '张北县'},
                  {id: 150, name: '康保县'},
                  {id: 151, name: '沽源县'},
                  {id: 152, name: '尚义县'},
                  {id: 153, name: '蔚县'},
                  {id: 154, name: '阳原县'},
                  {id: 155, name: '怀安县'},
                  {id: 156, name: '万全县'},
                  {id: 157, name: '怀来县'},
                  {id: 158, name: '涿鹿县'},
                  {id: 159, name: '赤城县'},
                  {id: 160, name: '崇礼县'}
                ]},
              {id: 10, name: '承德市', district: [
                  {id: 161, name: '双桥区'},
                  {id: 162, name: '双滦区'},
                  {id: 163, name: '鹰手营子矿区'},
                  {id: 164, name: '承德县'},
                  {id: 165, name: '兴隆县'},
                  {id: 166, name: '平泉县'},
                  {id: 167, name: '滦平县'},
                  {id: 168, name: '隆化县'},
                  {id: 169, name: '丰宁满族自治县'},
                  {id: 170, name: '宽城满族自治县'},
                  {id: 171, name: '围场满族蒙古族自治县'}
                ]},
              {id: 11, name: '沧州市', district: [
                  {id: 172, name: '新华区'},
                  {id: 173, name: '运河区'},
                  {id: 174, name: '沧县'},
                  {id: 175, name: '青县'},
                  {id: 176, name: '东光县'},
                  {id: 177, name: '海兴县'},
                  {id: 178, name: '盐山县'},
                  {id: 179, name: '肃宁县'},
                  {id: 180, name: '南皮县'},
                  {id: 181, name: '吴桥县'},
                  {id: 182, name: '献县'},
                  {id: 183, name: '孟村回族自治县'},
                  {id: 184, name: '泊头市'},
                  {id: 185, name: '任丘市'},
                  {id: 186, name: '黄骅市'},
                  {id: 187, name: '河间市'}
                ]},
              {id: 12, name: '廊坊市', district: [
                  {id: 188, name: '安次区'},
                  {id: 189, name: '广阳区'},
                  {id: 190, name: '固安县'},
                  {id: 191, name: '永清县'},
                  {id: 192, name: '香河县'},
                  {id: 193, name: '大城县'},
                  {id: 194, name: '文安县'},
                  {id: 195, name: '大厂回族自治县'},
                  {id: 196, name: '霸州市'},
                  {id: 197, name: '三河市'}
                ]},
              {id: 13, name: '衡水市', district: [
                  {id: 198, name: '桃城区'},
                  {id: 199, name: '枣强县'},
                  {id: 200, name: '武邑县'},
                  {id: 201, name: '武强县'},
                  {id: 202, name: '饶阳县'},
                  {id: 203, name: '安平县'},
                  {id: 204, name: '故城县'},
                  {id: 205, name: '景县'},
                  {id: 206, name: '阜城县'},
                  {id: 207, name: '冀州市'},
                  {id: 208, name: '深州市'}
                ]}
            ]}
        ]
      }
    },
    components: {
    },
    computed: {

    },
    created(){
    },
    methods: {
      //点击头像事件
      canChangePic(){

      },
      //身份证输入操作
      checkIdCard(){
        if(util.verifyIDCard(this.idCard)){
          console.log('你输入的是合法的')
        }else {
          console.log('你输入的证件号有误')
        }
      },
      //性别选择操作
      onValuesChange(picker, values) {
        console.log(values)
        this.userSex = values[0];
        this.sexVisible = false;
      },
      areaSelectHandler(){
        this.showChose = true;
      },
      //省市区乡选择操作
      closeAdd(){
        this.showChose = false;
      },
      _filter(add,name,code){
        let result = [];
        for(let i=0;i<add.length;i++) {
          if(code == add[i].id){
            result = add[i][name];
          }
        }
        return result;
      },
      getProvinceId(code,input,index){
        this.province = code;
        this.Province = input;
        this.showProvince=false;
        this.showCity=true;
        this.showDistrict = false;
        this.showTown = false;
        this.showCityList = this._filter(this.info,'city',this.province);
        // 点击选择当前
        this.info.map( a => a.selected = false );
        this.info[index].selected = true;
      },
      provinceSelected(){
        // 清除市级区级及乡级列表
        this.showCityList = false;
        this.showDistrictList = false;
        this.showTown = false;
        // 清除市级和区级及乡级选项
        this.City = false;
        this.District = false;
        this.Town = false;
        // 选项页面的切换
        this.showProvince = true;
        this.showCity = false;
        this.showDistrict = false;
        this.Town = false;
      },
      getCityId(code, input, index){
        this.city = code;
        this.City = input;
        this.showProvince=false;
        this.showCity=false;
        this.showDistrict = true;
        this.showTown = false;
        this.showDistrictList = this._filter(this.showCityList,'district',this.city);
        // 选择当前添加active
        this.showCityList.map( a => a.selected = false );
        this.showCityList[index].selected = true;
      },
      citySelected(){
        // 清除区级及乡级列表
        this.showDistrictList = false;
        this.showTown = false;
        // 清除区级及乡级选项
        this.District = false;
        this.Town = false;

        this.showProvince=false;
        this.showCity=true;
        this.showDistrict = false;
        this.showTown = false;
      },
      getDistrictId(code, input, index){
        this.district = code;
        this.District = input;

        this.showProvince=false;
        this.showCity=false;
        this.showDistrict = false;
        this.showTown = true;

        this.showTownList = this._filter(this.showDistrictList,'town',this.district);
        // 选择当前添加active
        this.showDistrictList.map( a => a.selected = false );
        this.showDistrictList[index].selected = true;
        // 选取市区选项之后关闭弹层
        // this.showChose = false;
      },
      districtSelected(){
        // 清除乡级列表
        this.showTown = false;
        // 清除乡级选项
        this.Town = false;

        this.showProvince=false;
        this.showCity=false;
        this.showDistrict = true;
        this.showTown = false;
      },
      getTownId(code, input, index){
        this.town = code;
        this.Town = input;

        // 选择当前添加active
        this.showTownList.map( a => a.selected = false );
        this.showTownList[index].selected = true;
        // 选取乡镇选项之后关闭弹层
        this.showChose = false;
      },
      townSelected(){
        this.showProvince=false;
        this.showCity=false;
        this.showDistrict = false;
        this.showTown = true;
      },
      //点击保存操作
      saveInfo(){

      }
    }
  }
</script>

<style scoped lang="scss">
  .improve-info-wrapper{
    background-color: #ffffff;
    width: 100%;
    height: 100%;
    position: fixed;
    .basic-content{
      .title{
        @include flex;
        @include align-items;
        height: 46px;
        color: #41B7A7;
        font-size: 15px;
        padding-left: 15px;
        &:before{
          content: '';
          position: absolute;
          left: 0;
          width: 4px;
          height: 20px;
          background-color: #41B7A7;
          border-radius: 0 1px 1px 0;
        }
      }
    }
    .item-basic{
      @include flex;
      @include align-items;
      @include justify-content(space-between);
      height: 46px;
      border-top: 1PX solid #EEEEEE;
      box-sizing: border-box;
      padding-left: 15px;
      .label{
        color: #666666;
        font-size: 15px;
        @include flex-value(1);
      }
      .right-info{
        color: #999999;
        font-size: 15px;
        margin-right: 37px;
        .user-pic{
          width: 40px;
          height: 40px;
        }
      }
      .right-info-select{
        color: #999999;
        font-size: 15px;
        margin-right: 10px;
        display: inline-block;
        @include flex;
        @include align-items;
        .show-area{
          color: #666666;
        }
        .inp{
          min-width: 60px;
          text-align: right;
          color: #666666;
          line-height: 25px;
          &::-webkit-input-placeholder { /* WebKit browsers */
            color: #999;
          }
          &:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
            color: #999;
          }
          &::-moz-placeholder { /* Mozilla Firefox 19+ */
            color: #999;
          }
          &:-ms-input-placeholder { /* Internet Explorer 10+ */
            color: #999;
          }
          &.margin-r{
            margin-right: 27px;
          }
        }
        .arrow-icon{
          width: 25px;
          height: 25px;
          margin-left: 2px;
        }
      }
      &.border-b{
        border-bottom: 1PX solid #EEEEEE;
      }
    }
    .divider-7pt{
      width: 100%;
      height: 7px;
      background-color: #F8F8F8;
    }
    .popup-content{
      width: 375px;
    }
    .fixed-btn{
      width: 100%;
      height: 45px;
      position: fixed;
      bottom: 0;
      left: 0;
      font-size: 16px;
      color: #FFFFFF;
      line-height: 45px;
      text-align: center;
      background-color: #41B7A7;
      z-index: 100;
      &.disabled{
        background-color: #CCCCCC;
      }
    }
    /*四级联动样式*/
    .province-picker{
      width: 100%;
      /*background-color: white;*/
      /*border-top: 4px solid rgba(245,245,245,1);*/
      /*color:#333;*/
    }
    .showChose{
      width:100%;
      height:100%;
      position:fixed;
      top:0;
      left:0;
      z-index:120;
      background:rgba(0,0,0,0.6);
      .address{
        position:absolute;
        bottom:0;
        left:0;
        z-index:121;
        background:#fff;
        width:100%;
        .title1{
          border-bottom: 1PX solid #EEEEEE;
          .address-name{
            display:inline-block;
            text-align: center;
            margin-left: 150px;
            font-size: 16px;
            line-height: 42px;
            color:#999;
          }
          .close-btn{
            margin: 0 0 0 100px;
            font-size: 22px;
            line-height: 40px;
            padding: 2px 20px;
            color:#D8D8D8;
          }
        }
        .title2{
          /*border-bottom: 1PX solid #EEEEEE;*/
          .area{
            display:inline-block;
            font-size: 12px;
            line-height: 35px;
            margin-left: 15px;
            color:#333;
            &.active{
              color:#0071B8;
              border-bottom:2px solid #0071B8;
            }
          }
        }
        ul{
          box-sizing: border-box;
          /*width:95%;*/
          width: 100%;
          height:100%;
          max-height: 350px;
          overflow:auto;
          li.add-list{
            box-sizing: border-box;
            width:100%;
            /*padding-left:0.32rem;*/
            font-size: 12px;
            line-height: 35px;
            color:#333;
            /*margin-left:5%;*/
            padding-left: 5%;
            &.active{
              color:#0071B8;
            }
          }
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/views/goBind/improveUserInfo.vue